<template>
    <modal :show.sync=show modalClasses="medium-sized-modal modal-hide-footer">
        <h3 slot="header" class="mb-0 font-weight-500">Edit Hub Details</h3>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form role="form">
                <b-row>
                    <b-col cols="12">
                        <b-form-group label="Hub Name">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'hubName'"
                            >
                                <b-form-input
                                v-model="form.group_name"
                                placeholder="Enter Hub Name"
                                required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Hub Manager">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'hubManager'"
                            >
                                <el-select v-model="form.group_owner_id" filterable placeholder="Select Hub Manager">
                                    <el-option v-for="option in userList"
                                        :key="option.id"
                                        :label="option.name"
                                        :value="option.id">
                                    </el-option>
                                </el-select>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group> 
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Hub Assistant Manager">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :vid="'hubAssistantManager'"
                            >
                                <el-select v-model="form.group_sub_owner_id" filterable placeholder="Select Hub Assistant Manager">
                                    <el-option :key="null" :label="'---Select---'" :value="null"></el-option>
                                    <el-option v-for="option in userList"
                                        :key="option.id"
                                        :label="option.name"
                                        :value="option.id">
                                    </el-option>
                                </el-select>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group> 
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="mx-auto text-center mt-4 pt-2">
                        <b-button type="submit" class="w-100" variant="primary" @click.prevent="updateHubDetails()" :disabled="invalid">Save</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </modal>
</template>
<script>
import Modal from "@/components/Modal";
import { Option, Select, Radio, RadioGroup } from 'element-ui'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'
import {
notifyFunctionMixin,
helperFunctionMixin,
axios,
services,
getHeader
} from '@/assets/js/httpImports.js'
import { mapState, mapActions } from 'pinia'
import { useHubStore } from '@/stores/hubStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import mainEventBus from '@/assets/js/mainEventBus.js'

export default {
    props:{
        show_edit_hub: Boolean
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        [Option.name]: Option,
        [Select.name]: Select,
        [Radio.name]: Radio,
        [RadioGroup.name]: RadioGroup,
    },
    computed: {
        show: {
            get() {
                return this.show_edit_hub;
            },
            set(newVal) {
                this.$emit('update:show_edit_hub', newVal);
            },
        },

        ...mapState(useHubStore,['current_hub', 'current_team_group']),
        ...mapState(useAccessControlStore,['userList', 'hubManagerUserList'])
    },
    data(){
        return {
            form: {},
            selectTypeOptions: [],
            selectHubManagerOptions: [],
        }
    },
    async created() {
        // this.hubManagerList();

        this.$watch(
            () => this.current_team_group,
            (newVal) => {
                if (newVal) {
                    this.form = newVal
                }
            },
            { immediate: true }
        )
    },
    methods: {
        ...mapActions(useHubStore,['getHub', 'getTeamGroup']),
        hubManagerList() {
            axios.get(services.access_control + 'user_list_by_role/hub manager', { headers: getHeader() })
            .then(response => {
                this.selectHubManagerOptions = response.data.data
            })
            .catch ( error => {
                this.errorFunction(error, "Showing Hub Listing failed: " + error.response.data.message) 
            });
        },
        updateHubDetails() {
            const postData = {
                group_name: this.form.group_name,
                group_owner_id: this.form.group_owner_id,
                group_sub_owner_id: this.form.group_sub_owner_id,
            }

            axios.put(services.commission + 'team-group/' + this.current_team_group.team_group_id , postData ,{ headers: getHeader() })
            .then ( response => {
                if (response.status === 200)
                {
                    this.$notify({
                    message:
                        '<b>Hub : ' + response.data.data.group_name + '</b> - Successfully Updated.',
                    timeout: 10000,
                    icon: 'ni ni-bell-55',
                    type: 'default',
                    });
                    this.$emit('update:show_edit_hub', false);
                    this.getTeamGroup(this.current_team_group.team_group_id)
                    mainEventBus.$emit('refresh-hub-listing')
                }
            })
            .catch ( error => {
                this.errorFunction(error)
            });
        }
    }
}
</script>